module.exports = __webpack_public_path__ + "img/1729146840146-IMG_4680.jpeg.adc70b40.webp";